<template lang="pug">
el-row(:gutter="20")
  el-col(:span="3" v-if="!hideText") {{ $t('报价') }}
  el-col(:span="21")
    el-table(
      :data="quotationData.quotation"
    )
      el-table-column(
        :label="$t('服务类型')"
        width="150"
      )
        template(slot-scope="scope")
          span {{ isZh && scope.row.star_service_name_ch ? scope.row.star_service_name_ch : scope.row.star_service_name }}
      el-table-column(
        :label="$t('服务项目')"
        width="180"
      )
        template(slot-scope="scope")
          span {{ isZh && scope.row.star_service_item_name_ch ? scope.row.star_service_item_name_ch : scope.row.star_service_item_name }}
      el-table-column(
        width="120"
        :label="$t('单价')"
      )
        template(slot-scope="scope")
          span {{ scope.row.unit_price | formatMoney }}
      el-table-column(
        prop="number"
        :label="$t('数量')"
        width="80"
      )
      el-table-column(
        label=""
        width="180"
        align="right"
      )
        template(slot-scope="scope")
          span {{ scope.row.total_price | formatMoney }}
    .table-summary(v-if="quotationData.tax_total_price")
      .table-summary_row
        span {{ $t('折扣') }}
        span {{ quotationData.discount | formatMoney }}
      .table-summary_row
        span {{ $t('税费') }}
        span {{ quotationData.tax_price | formatMoney }}
      .table-summary_row
        span {{ $t('总计') }}
        span {{ quotationData.tax_total_price | formatMoney }}
</template>

<script>
import db from '@/umcc/db'
import { formatMoney } from '@/umcc/util'
export default {
  props: {
    quotationData: {
      type: Object,
      default () {
        return {}
      }
    },
    hideText: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    isZh () {
      return db.lang === 'zh'
    }
  },
  filters: {
    formatMoney
  }
}
</script>

<style scoped lang="stylus">
.table-summary
  display flex
  flex-direction column
  align-items flex-end
  width 715px
  .table-summary_row
    box-sizing border-box
    width 220px
    padding 0 15px
    display flex
    justify-content space-between
    align-items center
    height 30px
</style>
